var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsPolitics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "White-House-Dc--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "White House DC Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 16.09h3.28v-2.7a1.73 1.73 0 0 1 3.46 0v2.7H17V8.93H7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.38 8.93H24v7.16h-5.62Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.93h5.62v7.16H0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.37 4.84v-0.51a0.75 0.75 0 0 0 -1.5 0v0.51H15.1l2.38 2.36 0.72 0.71H24V4.84Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 4.84H5.61v-0.51a0.75 0.75 0 0 0 -1.5 0v0.51H0v3.07h5.8l0.72 -0.71Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.58 22.5h-2.83v-1.81c0 -0.87 0.6 -0.91 0.86 -0.63a0.88 0.88 0 0 1 0.2 0.63 0.75 0.75 0 0 0 1.5 0A2 2 0 0 0 12 18.91a2 2 0 0 0 -3.31 1.78 0.75 0.75 0 0 0 1.5 0c0 -0.87 0.6 -0.91 0.86 -0.63a0.88 0.88 0 0 1 0.2 0.63v1.81H8.42a0.75 0.75 0 0 0 0 1.5h7.16a0.75 0.75 0 0 0 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 3.92 -4 4h9.56l-4 -4v-0.8h1.81a0.75 0.75 0 0 0 0.75 -0.75V0.75a0.76 0.76 0 0 0 -0.81 -0.75H12a0.76 0.76 0 0 0 -0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsPolitics);
export default ForwardRef;